import { render } from "./Galery.vue?vue&type=template&id=41695fa1&scoped=true"
import script from "./Galery.vue?vue&type=script&lang=js"
export * from "./Galery.vue?vue&type=script&lang=js"

import "./Galery.vue?vue&type=style&index=0&id=41695fa1&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-41695fa1"

export default script